import React from 'react';
import ListOutput from './ListOutput/ListOutput';

const OutputDetails = (props) =>{
    return <ListOutput {...props} />
}
export default OutputDetails;


// WEBPACK FOOTER //
// ./src/Containers/OutputDetails/OutputDetails.js